import React from "react";
import Language from "../lib/Language";

type TTooManyObjectsMessageProps = {
    style: {
        height?: number;
    };
    numObjects: number;
    onClick: () => void;
};

const TooManyObjectsMessage = (props: TTooManyObjectsMessageProps) => {
    return (
        <div className="tooManyObjects" style={props.style}>
            {Language.get("nc_object_list_x_objects_found", props.numObjects)}
            <br />
            {Language.get("nc_object_list_narrow_search")}
            <br />
            <br />
            <button
                style={{
                    width: "unset",
                    height: "unset",
                    paddingTop: "3px",
                    paddingBottom: "3px",
                }}
                className="deprecated modernButton grey"
                title={Language.get("nc_object_list_show_all")}
                onClick={props.onClick}
            >
                {Language.get("nc_object_list_show_all")}
            </button>
        </div>
    );
};

export default TooManyObjectsMessage;
